import { ForgotPasswordLink } from '@layout/LoginPage';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Button, SuccessMessage, ErrorMessage, TextField } from '@atoms';
import { UtilityPageTemplate } from '@templates';

export class ForgotPasswordPage extends Component {
  static propTypes = {
    goToLoginOnClick: PropTypes.func.isRequired,
    requestForResetPasswordByEmail: PropTypes.func.isRequired,
    changePasswordByToken: PropTypes.func.isRequired,
    resetForgotPasswordForm: PropTypes.func.isRequired,
    forgotPasswordFormRequestSuccess: PropTypes.bool,
    forgotPasswordLoading: PropTypes.bool.isRequired,
    forgotPasswordFormChangeSuccess: PropTypes.bool,
    forgotPasswordFormRequestFail: PropTypes.bool,
    forgotPasswordFormChangeFail: PropTypes.bool,
    token: PropTypes.string,
    userId: PropTypes.string,
  };

  state = {
    email: '',
    password: '',
  };

  handleSubmitRequest = (event) => {
    event.preventDefault();
    this.props.requestForResetPasswordByEmail(this.state.email);
  };

  handleSubmitChange = (event) => {
    event.preventDefault();
    const { userId, token } = this.props;
    this.props.changePasswordByToken(userId, this.state.password, token);
  };

  renderForm = () => {
    const {
      forgotPasswordFormRequestSuccess,
      forgotPasswordFormChangeSuccess,
      token,
      userId,
      forgotPasswordLoading,
    } = this.props;

    if (forgotPasswordFormRequestSuccess || forgotPasswordFormChangeSuccess) return null;

    if (token && userId) {
      return (
        <form onSubmit={this.handleSubmitChange}>
          <TextField
            id="password"
            title="Password"
            type="password"
            required
            onChange={(event, password) => this.setState({ password })}
            floatingLabelText="Password"
            disabled={forgotPasswordLoading}
          />
          <Button
            primary
            type="submit"
            id="recover"
            fullWidth
            loading={forgotPasswordLoading}
          >
            Recover Password
          </Button>
        </form>
      );
    }
    return (
      <form onSubmit={this.handleSubmitRequest}>
        <TextField
          id="email"
          title="Email"
          type="email"
          required
          onChange={(event, email) => this.setState({ email })}
          floatingLabelText="Email"
          disabled={forgotPasswordLoading}
        />
        <Button
          primary
          type="submit"
          id="recover"
          fullWidth
          loading={forgotPasswordLoading}
        >
          Recover Password
        </Button>
      </form>
    );
  };

  renderMessage = () => {
    const {
      forgotPasswordFormChangeSuccess,
      forgotPasswordFormRequestSuccess,
      forgotPasswordFormRequestFail,
      forgotPasswordFormChangeFail,
    } = this.props;

    if (forgotPasswordFormRequestSuccess) {
      return (
        <SuccessMessage>
          <span id="forgot-password-form-request-success">
            Your password has been reset, please check your email.
          </span>
        </SuccessMessage>
      );
    }

    if (forgotPasswordFormChangeSuccess) {
      return (
        <SuccessMessage>
          <span id="forgot-password-form-change-success">
            Your password has been changed.
          </span>
        </SuccessMessage>
      );
    }

    if (forgotPasswordFormRequestFail) {
      return (
        <ErrorMessage>
          <span id="forgot-password-form-request-fail">
            Failed to reset your password, please double-check your email address.
          </span>
        </ErrorMessage>
      );
    }

    if (forgotPasswordFormChangeFail) {
      return (
        <ErrorMessage>
          <span id="forgot-password-form-change-fail">
            Failed to reset your password, please double-check your password.
          </span>
        </ErrorMessage>
      );
    }

    return null;
  };

  renderLoginLink = () => (
    <ForgotPasswordLink>
      <a onClick={this.props.goToLoginOnClick}>Return To Login</a>
    </ForgotPasswordLink>
  );

  componentWillUnmount() {
    this.props.resetForgotPasswordForm();
  }

  render() {
    return (
      <UtilityPageTemplate title="Recover Password">
        {this.renderMessage()}
        {this.renderForm()}
        {this.renderLoginLink()}
      </UtilityPageTemplate>
    );
  }
}



// WEBPACK FOOTER //
// ./components/pages/ForgotPasswordPage/ForgotPasswordPage.js